import { Component, OnInit, isDevMode, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from 'src/app/services';
import { PartnerService } from '../../../../services/partner.service';
import { PaymentService } from '../../../../services/payment.service';
import { PosIntegrationService } from "../../../../services/pos-integration.service";

interface MenuItem {
  title: string;
  icon: string;
  classId: string;
  description: string;
  path: string;
  requiredRoles?: ('admin' | 'manager' | 'serviceLead' | 'shopRideAdmin')[];
}

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SettingsComponent implements OnInit {
  public messaging: any = [];
  public productsAndServices: any = [];
  public general: any = [];
  public plugins: any = [];
  public partner: any;
  public services: any = [];
  public payments: any = [];
  public workflow: any = [];
  searchTerm = '';

  originalSmessaging = [];
  originalSproductsAndServices = [];
  originalSgeneral = [];
  originalSplugins = [];
  originalSservices = [];
  originalSpayments = [];
  originalSworkflow = [];

  public isAdmin = false;
  public isManager = false;
  public isServiceLead = false;
  public isShopRideAdmin = false;

  constructor(
    private translate: TranslateService,
    private helpersService: HelpersService,
    public partnerService: PartnerService,
    private paymentService: PaymentService,
    private posIntegrationService: PosIntegrationService,
  ) { }

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();
    this.getUserPermissions();
    this.setupMenuOptions();

    if (
      this.partner.POSSystemID === 6 ||
      this.partner.POSSystemID === 3 ||
      this.partner.POSSystemID === 8 ||
      this.partner.POSSystemID === 9 ||
      this.partner.POSSystemID === 11 ||
      this.partner.POSSystemID === 19 ||
      this.partner.POSSystemID <= 0
    ) {
      const onlinePayment: MenuItem = {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.online_payments',
        ),
        icon: 'hubtiger-stripe',
        classId: 'settings-online-payments',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.in_app_payments',
        ),
        path: 'store/inapp-payment-configuration',
        requiredRoles: ['admin', 'manager'],
      };
      if (this.canAccessMenuItem(onlinePayment)) {
        this.payments.push(onlinePayment);
      }
    }

    if (this.partner.POSSystemID !== 17) {
      const coupons: MenuItem = {
        title: this.translate.instant('bikeshop.menu.coupons'),
        icon: 'hubtiger-coupon',
        classId: 'settings-coupons',
        description: this.translate.instant('bikeshop.menu.coupons_description'),
        path: '/store/coupons',
        requiredRoles: ['admin', 'manager', 'serviceLead'],
      };
      if (this.canAccessMenuItem(coupons)) {
        this.payments.push(coupons);
      }
    }

    if (this.partner.Country == 'ZA') {
      const paystackDeposits: MenuItem = {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.paystack_deposits',
        ),
        icon: 'hubtiger-cash',
        classId: 'workshop-paystack-deposits',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.paystack_deposits',
        ),
        path: 'store/paystack-configuration',
        requiredRoles: ['admin', 'manager'],
      };
      if (this.canAccessMenuItem(paystackDeposits)) {
        this.payments.push(paystackDeposits);
      }
    }

    if (this.partner.POSSystemID == 6 && this.partner.ManageStock) {
      const inventoryBookedOut: MenuItem = {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.inventory_booked_out',
        ),
        icon: 'hubtiger-pos',
        classId: 'settings-inventory-booked-out',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.inventory_booked_out',
        ),
        path: 'store/inventory-summary',
        requiredRoles: ['admin', 'manager'],
      };
      if (this.canAccessMenuItem(inventoryBookedOut)) {
        this.productsAndServices.push(inventoryBookedOut);
      }
    }

    this.paymentService
      .checkPartnerLinkedStripeConnect(this.partner.ID)
      .subscribe((res) => {
        if (
          res.linked &&
          (this.partner.POSSystemID === 6 ||
            this.partner.POSSystemID === 3 ||
            this.partner.POSSystemID === 9 ||
            this.partner.POSSystemID === 12 ||
            this.partner.POSSystemID === 13 ||
            this.partner.POSSystemID === 19 ||
            this.partner.POSSystemID <= 0)
        ) {
          const serviceDeposits: MenuItem = {
            title: this.translate.instant(
              'bikeshop.shop_setup.card_headers.service_deposits_short',
            ),
            icon: 'hubtiger-stripe',
            classId: 'settings-service-deposits',
            description: this.translate.instant(
              'bikeshop.shop_setup.card_description.service_deposits',
            ),
            path: 'store/service-deposit-configuration',
            requiredRoles: ['admin', 'manager'],
          };
          if (this.canAccessMenuItem(serviceDeposits)) {
            this.payments.push(serviceDeposits);
          }
        }
      });

    this.paymentService
      .getPartnerPaystackConfig(this.helpersService.getPartnerId())
      .subscribe(
        (config) => {
          if (config.linked &&
            (this.partner.POSSystemID === 6 ||
              this.partner.POSSystemID === 3 ||
              this.partner.POSSystemID === 9 ||
              this.partner.POSSystemID === 12 ||
              this.partner.POSSystemID === 13 ||
              this.partner.POSSystemID <= 0)
          ) {
            const serviceDeposits: MenuItem = {
              title: this.translate.instant(
                'bikeshop.shop_setup.card_headers.service_deposits_short',
              ),
              icon: 'hubtiger-stripe',
              classId: 'settings-service-deposits',
              description: this.translate.instant(
                'bikeshop.shop_setup.card_description.service_deposits',
              ),
              path: 'store/service-deposit-configuration',
              requiredRoles: ['admin', 'manager'],
            };
            if (this.canAccessMenuItem(serviceDeposits)) {
              this.payments.push(serviceDeposits);
            }
          }
        });


    this.posIntegrationService
      .getPartnerPOSConfiguration(this.helpersService.getPartnerId())
      .subscribe(
        (config) => {
          console.log('POS Config', config);
          console.log('Partner', this.partner);
          if (
            (this.partner.POSSystemID === 6 ||
              this.partner.POSSystemID === 3 ||
              this.partner.POSSystemID === 9 ||
              this.partner.POSSystemID === 12 ||
              this.partner.POSSystemID === 13 ||
              this.partner.POSSystemID <= 0)
          ) {
            const serviceDeposits: MenuItem = {
              title: this.translate.instant(
                'bikeshop.shop_setup.card_headers.service_deposits_short',
              ),
              icon: 'hubtiger-stripe',
              classId: 'settings-service-deposits',
              description: this.translate.instant(
                'bikeshop.shop_setup.card_description.service_deposits',
              ),
              path: 'bikeshop/service-deposit-configuration',
              requiredRoles: ['admin', 'manager'],
            };
            if (this.canAccessMenuItem(serviceDeposits)) {
              this.payments.push(serviceDeposits);
            }
          }
        });

    if (
      this.partner.PartnerType === 1 &&
      (this.partner.POSSystemID == 9 ||
        this.partner.POSSystemID == 6 ||
        this.partner.POSSystemID == 3)
    ) {
      const bikeSales: MenuItem = {
        title: this.translate.instant('bike.sale_title'),
        icon: 'hubtiger-cash',
        classId: 'settings-bike-sales',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.checklist_configuration',
        ),
        path: 'store/bike-sales',
        requiredRoles: ['admin', 'manager', 'serviceLead'],
      };
      if (this.canAccessMenuItem(bikeSales)) {
        this.productsAndServices.push(bikeSales);
      }
    }
  }

  setupMenuOptions() {
    this.setupMessagingOptions();
    this.setupProductsAndServicesOptions();
    this.setupGeneralOptions();
    this.setupPluginsOptions();

    this.setupPaymentOptions();
    this.setupServicesOptions();
    this.setupWorkflowOptions();

    this.setupOriginal();
    //this.setupRentalsOptions();
  }

  setupOriginal() {
    this.originalSmessaging = [...this.messaging];
    this.originalSproductsAndServices = [...this.productsAndServices];
    this.originalSgeneral = [...this.general];
    this.originalSplugins = [...this.plugins];
    this.originalSservices = [...this.services];
    this.originalSpayments = [...this.payments];
    this.originalSworkflow = [...this.workflow];
  }

  resetFilters() {
    this.messaging = [...this.originalSmessaging];
    this.productsAndServices = [...this.originalSproductsAndServices];
    this.general = [...this.originalSgeneral];
    this.plugins = [...this.originalSplugins];
    this.services = [...this.originalSservices];
    this.workflow = [...this.originalSworkflow];
  }

  setupWorkflowOptions() {
    this.workflow.push(
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.pick-ups/deliveries_setup',
        ),
        icon: 'hubtiger-pickup',
        classId: 'settings-pick-ups-deliveries-setup',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.pick-ups/deliveries_setup',
        ),
        path: 'store/pick-ups-delivery-setup',
        requiredRoles: ['admin', 'manager'],
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.custom_workshop_questions',
        ),
        icon: 'hubtiger-pos',
        classId: 'settings-custom-workshop-questions',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.custom_workshop_questions',
        ),
        path: 'store/custom-questions-config',
        requiredRoles: ['admin', 'manager', 'serviceLead'],
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.checklist_configuration',
        ),
        icon: 'hubtiger-checklist',
        classId: 'settings-checklist-configuration',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.checklist_configuration',
        ),
        path: 'store/checklist-configuration',
        requiredRoles: ['admin', 'manager', 'serviceLead'],
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.waivers',
        ),
        icon: 'hubtiger-pos',
        classId: 'settings-waivers',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.waivers',
        ),
        path: 'store/waivers-config',
        requiredRoles: ['admin', 'manager'],
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.third_parties',
        ),
        icon: 'hubtiger-third-party',
        classId: 'settings-third-parties',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.third_parties',
        ),
        path: 'store/third-party',
        requiredRoles: ['admin', 'manager', 'serviceLead'],
      },
    );
    this.workflow = this.filterByRole(this.workflow);
  }

  setupMessagingOptions() {
    this.messaging = [
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.message_templates_short',
        ),
        icon: 'hubtiger-message-template',
        classId: 'settings-message-templates',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.message_templates',
        ),
        path: 'store/message-templates',
        requiredRoles: ['admin', 'manager'],
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.message_bundles',
        ),
        icon: 'hubtiger-message-bundle',
        classId: 'settings-message-bundles',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.message_bundles',
        ),
        path: 'store/purchase-messaging-bundle',
        requiredRoles: ['admin', 'manager'],
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.whatsapp_integration',
        ),
        icon: 'hubtiger-message-bundle',
        classId: 'settings-whatsapp-integration',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.whatsapp_integration',
        ),
        path: 'store/whatsapp-integration',
        requiredRoles: ['admin', 'manager'],
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.text_message_integration'
        ),
        icon: 'hubtiger-message-bundle',
        classId: 'settings-messaging-integration',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.text_message_integration'
        ),
        path: 'store/text-message-platform-integration',
        requiredRoles: ['admin', 'manager'],
      },
    ];
    this.messaging = this.filterByRole(this.messaging);
  }

  setupServicesOptions() {
    this.services.push(
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.service_types',
        ),
        icon: 'hubtiger-wrench',
        classId: 'settings-service-types',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.service_types',
        ),
        path: 'store/service-types',
        requiredRoles: ['admin', 'manager'],
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.fittings',
        ),
        icon: 'hubtiger-wrench',
        classId: 'settings-fittings',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.fittings',
        ),
        path: 'store/fittings',
        requiredRoles: ['admin', 'manager'],
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.service_imports',
        ),
        icon: 'hubtiger-calendar',
        classId: 'settings-service-imports',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.service_imports',
        ),
        path: 'store/service-imports',
        requiredRoles: ['admin', 'manager'],
      },
      // removing refferals until requested
      // {
      //   title: this.translate.instant(
      //     'bikeshop.shop_setup.card_headers.referrals',
      //   ),
      //   icon: 'hubtiger-cash',
      //   description: this.translate.instant(
      //     'bikeshop.shop_setup.card_description.referrals',
      //   ),
      //   path: 'store/referrals',
      // },
    );
    this.services = this.filterByRole(this.services);
  }

  setupPaymentOptions() {
    // this.payments.push();
    this.payments = this.filterByRole(this.payments);
  }

  setupProductsAndServicesOptions() {
    this.productsAndServices = [
      {
        title: this.translate.instant('bikeshop.menu.pos_products'),
        icon: 'hubtiger-pos',
        classId: 'settings-pos-products',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.pos_products',
        ),
        path: 'store/pos-products',
        requiredRoles: ['admin', 'manager'],
      },
    ];
    this.productsAndServices = this.filterByRole(this.productsAndServices);
  }

  setupGeneralOptions() {
    this.general = [
      {
        title: this.translate.instant('bikeshop.shop_setup.card_headers.users'),
        icon: 'hubtiger-profile',
        classId: 'settings-users',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.users',
        ),
        //path: isDevMode() ? 'store/user-management' : 'store/users'
        path: 'store/user-management',
        requiredRoles: ['admin', 'manager', 'serviceLead'],
      },
      // {
      //   title: this.translate.instant('bikeshop.shop_setup.card_headers.billing'),
      //   icon: 'hubtiger-cash',
      //   description: this.translate.instant('bikeshop.shop_setup.card_description.billing'),
      //   path: "bikeshop/pricing"
      // },

      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.shop_profile',
        ),
        icon: 'hubtiger-shop-profile',
        classId: 'settings-shop-profile',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.shop_profile',
        ),
        path: 'store/shop-profile',
        requiredRoles: ['admin', 'manager', 'serviceLead'],
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.other_settings',
        ),
        icon: 'hubtiger-settings',
        classId: 'settings-other-settings',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.other_settings',
        ),
        path: 'store/other-settings',
        requiredRoles: ['admin', 'manager', 'serviceLead'],
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.pos_integration',
        ),
        icon: 'hubtiger-settings',
        classId: 'settings-pos-integration',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.pos_setup',
        ),
        path: 'store/pos-integrations',
        requiredRoles: ['admin', 'manager', 'serviceLead'],
      },
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.manage_subscription',
        ),
        icon: 'hubtiger-cash',
        classId: 'settings-manage-subscription',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.manage_subscription',
        ),
        path: 'store/manage-subscription',
        requiredRoles: ['admin', 'manager'],
      },
    ];
    this.general = this.filterByRole(this.general);
  }

  setupPluginsOptions() {
    this.plugins = [
      {
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.website_widget',
        ),
        icon: 'hubtiger-settings',
        classId: 'settings-website-widget',
        description: this.translate.instant(
          'bikeshop.plugins.widget.description',
        ),
        //path: isDevMode() ? 'store/user-management' : 'store/users'
        path: 'store/widget-setup',
        //disabled: this.partner.PartnerType !== 1
        requiredRoles: ['admin', 'manager', 'serviceLead'],
      },
    ];

    if (this.partner.PartnerType === 1) {
      this.plugins.push({
        title: this.translate.instant(
          'bikeshop.shop_setup.card_headers.shop_rides_widget',
        ),
        icon: 'hubtiger-bike',
        classId: 'settings-shop-rides-widget',
        description: this.translate.instant(
          'bikeshop.shop_setup.card_description.shop_rides_widget',
        ),
        path: 'store/shop-rides-configuration',
        requiredRoles: ['admin', 'manager', 'serviceLead', 'shopRideAdmin'],
      });
    }
    this.plugins.push({
      title: this.translate.instant('bikeshop.receipt_template.designer',),
      icon: 'pencil',
      classId: 'settings-receipt-designer',
      description: '', // this.translate.instant('bikeshop.shop_setup.card_description.shop_rides_widget',),
      path: 'store/receipt-templates',
      requiredRoles: ['admin', 'manager', 'serviceLead'],
    });
    this.plugins = this.filterByRole(this.plugins);
  }

  searchSettings() {
    this.resetFilters();
    if (this.searchTerm.length > 0) {
      this.messaging = this.filterArray(this.messaging, this.searchTerm);
      this.productsAndServices = this.filterArray(
        this.productsAndServices,
        this.searchTerm,
      );
      this.general = this.filterArray(this.general, this.searchTerm);
      this.plugins = this.filterArray(this.plugins, this.searchTerm);
      this.services = this.filterArray(this.services, this.searchTerm);
      this.payments = this.filterArray(this.payments, this.searchTerm);
      this.workflow = this.filterArray(this.workflow, this.searchTerm);
    } else {
      this.resetFilters();
    }
  }

  filterArray(array: any[], searchTerm: string) {
    let tempArray = [];
    return (tempArray = array.filter((item) => {
      return this.translate
        .instant(item.title)
        .toLowerCase()
        .includes(this.searchTerm.toLowerCase());
    }));
  }

  checkIfSettings() {
    if (this.messaging.length > 0) {
      return true;
    }
    if (this.productsAndServices.length > 0) {
      return true;
    }
    if (this.general.length > 0) {
      return true;
    }
    if (this.plugins.length > 0) {
      return true;
    }
    if (this.services.length > 0) {
      return true;
    }
    if (this.payments.length > 0) {
      return true;
    }
    if (this.workflow.length > 0) {
      return true;
    }

    return false;
  }

  getUserPermissions() {
    var profile = this.helpersService.getProfileData();
    var roles = profile.UserRoles.filter((x) => {
      return x.PartnerID === this.helpersService.getPartnerId();
    });

    this.isAdmin = roles.map((x) => { return x.RoleID; }).indexOf(2) > -1 || profile.IsSuperUser;
    this.isManager = roles.map((x) => { return x.RoleID; }).indexOf(3) > -1;
    this.isServiceLead = roles.map((x) => { return x.RoleID; }).indexOf(9) > -1;
    this.isShopRideAdmin = roles.map((x) => { return x.RoleID; }).indexOf(10) > -1;
  }

  private filterByRole(items: MenuItem[]): MenuItem[] {
    return items.filter(item => {
      // If no roles specified, everyone can access
      if (!item.requiredRoles || item.requiredRoles.length === 0) {
        return true;
      }

      // Check if user has any of the required roles
      return item.requiredRoles.some(role => {
        switch (role) {
          case 'admin':
            return this.isAdmin;
          case 'manager':
            return this.isManager;
          case 'serviceLead':
            return this.isServiceLead;
          case 'shopRideAdmin':
            return this.isShopRideAdmin;
          default:
            return false;
        }
      });
    });
  }

  private canAccessMenuItem(item: MenuItem): boolean {
    if (!item.requiredRoles || item.requiredRoles.length === 0) {
      return true;
    }

    return item.requiredRoles.some(role => {
      switch (role) {
        case 'admin':
          return this.isAdmin;
        case 'manager':
          return this.isManager;
        case 'serviceLead':
          return this.isServiceLead;
        case 'shopRideAdmin':
          return this.isShopRideAdmin;
        default:
          return false;
      }
    });
  }
}
